export default function UserGuide({ onBack }) {
  const steps = [
    {
      title: "팀 만들기",
      sub: "팀장/회장이 하는 일",
      items: [
        "동호회 회장이나 모임 대표가 팀을 만들어요",
        "내 정보 → '새 팀 등록하기'",
        "종목, 지역, 팀 레벨, 활동 요일 등 입력",
        "팀을 만든 사람이 자동으로 팀장이 돼요",
      ],
    },
    {
      title: "팀원 등록",
      sub: "팀원이 하는 일",
      items: [
        "내 정보 → '팀 찾기' → 우리 팀 검색",
        "'팀원 가입 신청' 누르기",
        "팀장이 수락하면 팀원이 돼요",
        "팀장이 '초대 문구 복사'로 안내문을 공유할 수 있어요",
      ],
    },
    {
      title: "교류전 모집 & 신청",
      sub: "매칭",
      items: [
        "우리가 모집: '교류전 모집글 작성하기' → 날짜/장소/레벨 입력",
        "다른 팀에 신청: 모집글 보고 '신청하기'",
        "상대 팀에 어떤 사람들이 나오는지 미리 확인할 수 있어요 (프로필 공개한 팀원)",
        "상대 팀이 수락하면 매칭 완료!",
      ],
    },
    {
      title: "채팅 & 참가 인원 정하기",
      sub: "",
      items: [
        "매칭되면 두 팀이 채팅으로 소통해요",
        "채팅방에서 일정/장소 조율",
        "우리 팀원들이 '참가하기'로 누가 나갈지 표시",
        "사진도 주고받을 수 있어요",
      ],
    },
    {
      title: "점수 입력 & 레벨 올리기",
      sub: "",
      items: [
        "경기 끝나면 '결과 입력하기'로 점수 입력",
        "양 팀이 확인하면 전적에 반영",
        "경기가 쌓이면 팀 레벨이 올라가요",
        "매너 좋게 경기하면 매너 점수도 올라가요",
      ],
    },
  ];

  return (
    <div style={s.wrap}>
      {/* 헤더 */}
      <div style={s.header}>
        <button onClick={onBack} style={s.backBtn}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#111827" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <span style={s.headerTitle}>크루픽 사용 가이드</span>
      </div>

      <div style={s.body}>
        {/* 부제 */}
        <p style={s.subtitle}>처음이신가요? 크루픽 사용법을 알려드릴게요</p>

        {/* 단계 카드 */}
        {steps.map((step, idx) => (
          <div key={idx} style={s.card}>
            <div style={s.cardHeader}>
              <div style={s.badge}>{idx + 1}</div>
              <div>
                <div style={s.cardTitle}>{step.title}</div>
                {step.sub && <div style={s.cardSub}>{step.sub}</div>}
              </div>
            </div>
            <ul style={s.list}>
              {step.items.map((item, i) => (
                <li key={i} style={s.listItem}>
                  <span style={s.dot} />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div style={{ height: 40 }} />
      </div>
    </div>
  );
}

const s = {
  wrap: {
    minHeight: "100vh",
    background: "#f5f6fa",
    fontFamily: "'Noto Sans KR', sans-serif",
  },
  inner: {
    maxWidth: 500,
    margin: "0 auto",
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "calc(env(safe-area-inset-top) + 14px) 20px 14px",
    background: "#ffffff",
    borderBottom: "1px solid #edf0f3",
    position: "sticky",
    top: 0,
    zIndex: 10,
    boxShadow: "0 1px 6px rgba(0,0,0,0.05)",
    maxWidth: 500,
    margin: "0 auto",
  },
  backBtn: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: 4,
    display: "flex",
    alignItems: "center",
  },
  headerTitle: {
    fontSize: 18,
    fontWeight: 700,
    color: "#111827",
  },
  body: {
    padding: "20px 16px",
    maxWidth: 500,
    margin: "0 auto",
  },
  subtitle: {
    fontSize: 14,
    color: "#6b7280",
    marginBottom: 20,
    lineHeight: 1.5,
  },
  card: {
    background: "#ffffff",
    borderRadius: 14,
    padding: "18px 16px",
    marginBottom: 14,
    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
  },
  cardHeader: {
    display: "flex",
    alignItems: "flex-start",
    gap: 12,
    marginBottom: 14,
  },
  badge: {
    width: 30,
    height: 30,
    borderRadius: "50%",
    background: "#E8412A",
    color: "#ffffff",
    fontSize: 14,
    fontWeight: 800,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  cardTitle: {
    fontSize: 16,
    fontWeight: 700,
    color: "#1A1A2E",
    lineHeight: 1.3,
  },
  cardSub: {
    fontSize: 12,
    color: "#E8412A",
    fontWeight: 600,
    marginTop: 2,
  },
  list: {
    listStyle: "none",
    margin: 0,
    padding: 0,
    display: "flex",
    flexDirection: "column",
    gap: 8,
  },
  listItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: 8,
    fontSize: 13,
    color: "#4b5563",
    lineHeight: 1.5,
  },
  dot: {
    width: 5,
    height: 5,
    borderRadius: "50%",
    background: "#d1d5db",
    flexShrink: 0,
    marginTop: 7,
  },
};
